import React from 'react';
import PropTypes from 'prop-types';

function EmailContactsButton(props) {
  const {
    buttonText,
    buttonClass,
    clickEvent,
  } = props;

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={clickEvent}
    >
      <i className="fa-solid fa-address-book" aria-hidden="true" /> {buttonText}
    </button>
  );
}

EmailContactsButton.propTypes = {
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  clickEvent: PropTypes.func.isRequired,
};

EmailContactsButton.defaultProps = {
  buttonText: undefined,
  buttonClass: undefined,
};

export default EmailContactsButton;
